module.exports = JSON.parse('{"Clear dates":"Limpar datas","End Date":"Data Final","Start Date":"Data Inicial"}')